module.exports = __webpack_public_path__ + "img/img_chanpingshuju.cb6ea03d.png";